module.exports = __webpack_public_path__ + "img/Nouvel_an.4b56838.jpg";